import styled from 'styled-components'
import { FlowKey, Section as SectionType } from '../../pages/landing-page/types'
import {
  getResumeFlowKey,
  getStartFlowKey,
  getVisibleSummarySections,
  hasCompletedJourney,
  hasStartedJourney,
} from '../../pages/landing-page/utils'
import { Recommendation } from '../../../types/types'
import { track } from '../../../common/utils'
import { Action } from './action'
import { Identity } from './identity'
import { Income } from './income'
import { Residential } from './residential'
import { Guarantor } from './guarantor'
import { Organisation } from './organisation'
import { AdditionalDetails } from './additional-details'

export interface SummaryProps {
  sections: SectionType[]
  outstandingAction?: Recommendation
}

const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 1024px;
  padding: 0 24px;
  box-sizing: border-box;
`

const navigateToFlow = (flowKey: FlowKey) => {
  window.location.href = `${window.location.origin}/?flow=${flowKey}`
}

const navigateToBot = () => {
  window.location.href = `${window.location.origin}/`
}

const renderRequirementSection = (flowKey: FlowKey) => {
  switch (flowKey) {
    case 'identity':
      return <Identity key={flowKey} />
    case 'financial':
      return <Income key={flowKey} />
    case 'residential':
      return <Residential key={flowKey} />
    case 'guarantor':
      return <Guarantor key={flowKey} />
    case 'company':
      return <Organisation key={flowKey} />
    case 'additionalDetails':
      return <AdditionalDetails key={flowKey} />
    default:
      return null
  }
}

export const Summary = ({ sections, outstandingAction }: SummaryProps) => {
  const hasStarted = hasStartedJourney(sections)
  const isComplete = hasCompletedJourney(sections)
  const visibleSections = getVisibleSummarySections(sections)

  const handleStart = () => {
    const flowKey = getStartFlowKey(sections)
    track('Landing page click - navigation', { section: flowKey, action: 'start' })
    navigateToFlow(flowKey)
  }

  const handleContinue = () => {
    const flowKey = getResumeFlowKey(sections) ?? getStartFlowKey(sections)
    track('Landing page click - navigation', { section: flowKey, action: 'continue' })
    navigateToFlow(flowKey)
  }

  const handleOutstandingAction = () => {
    if (outstandingAction === undefined) {
      return
    }
    track('Outstanding action - navigation', {
      displayName: outstandingAction.displayName,
    })
    navigateToBot()
  }

  return (
    <SummaryList>
      <Action
        hasStarted={hasStarted}
        isComplete={isComplete}
        outstandingAction={outstandingAction}
        onStart={handleStart}
        onContinue={handleContinue}
        onOutstandingAction={handleOutstandingAction}
      />
      {visibleSections.map(renderRequirementSection)}
    </SummaryList>
  )
}

export default Summary
